import { useState } from "react";
import EyeOpen from "../Icons/EyeOpen";
import EyeClosed from "../Icons/EyeClosed";
import { InputTypeEnum } from "../../../types/enums/Inputs";

interface TextInputLabeledProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type: InputType;
}

type InputType = (typeof InputTypeEnum)[keyof typeof InputTypeEnum];

export default function TextInputLabeled({
  label,
  value,
  onChange,
  type,
}: TextInputLabeledProps) {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  return (
    <div className="flex flex-col gap-y-2">
      <label className="roboto-font text-gray-font font-normal text-base lg:text-lg ">
        {label}
      </label>
      <div className="relative">
        <input
          type={
            type === InputTypeEnum.PASSWORD
              ? showPassword
                ? "text"
                : "password"
              : type
          }
          className="w-full p-2 border border-gray-25 bg-gray-25 text-base lg:text-lg"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {type === InputTypeEnum.PASSWORD ? (
          <button
            type="button"
            className="right-3 top-1/2 -translate-y-1/2 absolute text-base lg:text-lg"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeOpen /> : <EyeClosed />}
          </button>
        ) : null}
      </div>
    </div>
  );
}
